import { FilterFormService } from '~/services/filter-form-service';

export default {
  install: (app) => {
    const {
      _context: { provides },
    } = app;
    const filterFormService = new FilterFormService(provides);

    app.provide('filterFormService', filterFormService);
  },
};
